<template>
    <div class="flex">
        <h4>Messaging</h4>
        <div class="messaging-container twelve columns">
            <div class="flex">
                <div>
                    <div class="twelve columns">
                        <input id="customMessage" v-model="customMessage" type="text"
                            placeholder="Custom Message">
                    </div>
                </div>
                <div class="send-btn-container">
                    <button class="sendMessageBtn marginSmallTop" type="submit"
                        @click.prevent="sendPodiumMessage">Send</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import apiMixin from '@/mixins/apiMixin.js'

export default {
    name: 'AuctionConsoleMessagingCard',
    components: {
    },
    mixins: [apiMixin],
    data() {
        return {
            customMessage: '',
        }
    },
    computed: {
        currentLiveInventoryId: function () {
            return this.$store.getters.currentLiveInventoryId
        },
        item: function () {
            if (this.$store.getters.item(this.currentLiveInventoryId) === null) {
                return {
                    inventory_id: 0,
                    lead_image: '',
                    display_lotnumber: '',
                    lead: ''
                }
            }
            return this.$store.getters.item(this.currentLiveInventoryId)
        },
    },
    mounted() {
    },
    methods: {
        /**
         * Send a message to the podium
         */
        sendPodiumMessage() {
            const payload = {
                'message': this.customMessage,
                'inventory_id': this.item.inventory_id
            }
            this.$store.dispatch('sendPodiumMessage', payload)
            this.customMessage = ''
        },
    },
}
</script>

<style scoped>

.messaging-container {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1.5em;
    padding: 1rem;
    border-radius: 4px;
    flex-grow: 1;
}

.send-btn-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}

.sendMessageBtn {
    background-color: #007AFF;
    color: white;
    border: 1px solid #007AFF;
    border-radius: 4px;
    margin-bottom: 0;
}
.flex {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
</style>